import { createMedia } from "@artsy/fresnel"

import { breakpointNames, breakpointValues } from "styles/theme/breakpoints"

const AppMedia = createMedia({
  breakpoints: {
    minimum: 0,
    ...breakpointNames.reduce(
      (accu, curr, index) => ({
        ...accu,
        [curr]: breakpointValues[index],
      }),
      {}
    ),
  },
})

export const mediaStyle = AppMedia.createMediaStyle()

export const { Media, MediaContextProvider } = AppMedia

export default Media
